module.exports = __webpack_public_path__ + "img/img_left.4f15f530.png";